import { createFileRoute } from '@tanstack/react-router';
import { PrestationTransactionsPage } from '@/features/beneficiaries/employees/transactions/components/PrestationTransactionsPage';

export const Route = createFileRoute('/$commiteeSlug/beneficiaries/transactions/{-$id}')({
  component: PrestationTransactionsPage,
});
